import type React from 'react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';

import {
  DateTypes,
  SKIP_REPROCESS_SUFFIX,
} from '../../../../automation-rules/modals/rule-editor-drawer/rule-actions/components/action-value-input/set-ship-date/set-ship-date';
import type { WorkflowActionInputProps } from '../../../registries/registry-types';
import { messages } from './messages';

export const ShipDateAuxiliaryInput: React.FC<WorkflowActionInputProps> = ({ draft, onUpdate }) => {
  const intl = useIntl();
  const isSkipReprocess = draft.parameter?.includes(SKIP_REPROCESS_SUFFIX) ?? false;

  const handleChange = useCallback(
    (checked: boolean) => {
      const baseParameter = draft.parameter?.replace(SKIP_REPROCESS_SUFFIX, '') ?? DateTypes.CurrentDate;
      onUpdate({ parameter: checked ? `${baseParameter}${SKIP_REPROCESS_SUFFIX}` : baseParameter });
    },
    [draft.parameter, onUpdate],
  );

  return (
    <Checkbox ariaLabel={intl.formatMessage(messages.skipReprocessing)} checked={isSkipReprocess} onChange={handleChange}>
      {intl.formatMessage(messages.skipReprocessing)}
    </Checkbox>
  );
};
